import React from 'react';
import {Modal, Button} from "semantic-ui-react";

export default class InformationModal extends React.Component {
    constructor(args) {
        super(args);

        this.state = {
            isOpen: false,
            title: "",
            message: "",
            promiseResolve: null
        };
    }

    open(title, message) {
        let promise = new Promise((resolve, reject) => {
            this.setState({
                isOpen: true,
                title: title,
                message: message,
                promiseResolve: resolve
            });
        });
        return promise;
    }

    close() {
		if (this.state.promiseResolve) {
			this.state.promiseResolve();
		}
        this.setState({
            isOpen: false,
            title: "",
            message: "",
            promiseResolve: null
        });
    }

    render() {
		let messageStyle = {
			whiteSpace: 'pre-line',
			wordBreak: 'break-word'
		};

        return <Modal
            closeIcon
            onClose={() => this.close()}
            open={this.state.isOpen}
            size="tiny"
        >
            {this.state.title && <Modal.Header>
                {this.state.title}
            </Modal.Header>}
            <Modal.Content className='modal__content'>
                <p style={messageStyle}>{this.state.message}</p>
            </Modal.Content>
            <Modal.Actions className='modal__actions'>
                <Button className='modal__actions_yes' onClick={() => this.close()}>OK</Button>
            </Modal.Actions>
        </Modal>
    }
}


// WEBPACK FOOTER //
// ./App/modals/infoModal.jsx